import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';
import { ToastrService } from 'ngx-toastr';
import { ObjectenService } from 'src/app/shared/dataservices/objecten.service';
import { ObjectSelect } from 'src/app/shared/model/models';

@Component({
  selector: 'app-object-select',
  templateUrl: './object-select.component.html',
  styleUrls: ['./object-select.component.less']
})


export class ObjectSelectComponent implements OnInit {


  @Output() selectionChanged = new EventEmitter<ObjectSelect>();
  relatieid: number;
  cpid: number;
  faseid: number;
  objectNR: number;
  omschrijving : string;

  relaties = [];
  contactpersonen = [];
  fasen = [];

  constructor(private relatiesService: RelatiesService,
              private objectenService: ObjectenService,
              private toastr: ToastrService) { }

  ngOnInit() {
    this.relatiesService.getActiveRelatieList().subscribe(data => {
      this.relaties = data;
    })
    this.objectenService.getFasen().subscribe(data=> this.fasen = data)
    this.relatieChange(null);
    this.cpChange(null);
    this.faseChange(1);
    this.objectNR = null;
    this.omschrijving = '';
    this.doFilter();
  }

  relatieChange(relatieID: any) {
    this.relatieid = relatieID;
    this.relatiesService.getContactpersonen(this.relatieid).subscribe(data => {
      this.contactpersonen = data;
    })
  }

  cpChange(data:any) {
    this.cpid = data;
  }

  faseChange(data:any) {
    this.faseid = data;
  }

  objNrChange(data:any) {
    this.objectNR = data;
  }


  doFilter() {
    let oselect = new ObjectSelect();
    oselect.cpid = this.cpid;
    oselect.faseid = this.faseid;
    oselect.relatieid = this.relatieid;
    oselect.objectNr = this.objectNR;
    oselect.omschrijving = this.omschrijving;
    localStorage.setItem("objectfilter",JSON.stringify(oselect));
    this.selectionChanged.emit(oselect)
  }

  doClear() {
    let oselect = new ObjectSelect();
    this.cpid = null;
    this.faseid = null;
    this.relatieid = null;
    this.objectNR = null;
    this.omschrijving = null;
    oselect.cpid = this.cpid;
    oselect.faseid = this.faseid;
    oselect.relatieid = this.relatieid;
    oselect.objectNr = this.objectNR;
    oselect.omschrijving = this.omschrijving;
    localStorage.setItem("objectfilter",JSON.stringify(oselect));
    this.selectionChanged.emit(oselect)
  }

}
